export const userSelector = (state) => state.user;
export const idPostedSelector = (state) => state.idPosted;
export const listPostSelector = (state) => state.listPost;
export const listPostProfileSelector = (state) => state.listPostProfile;
export const setTagPost = (state) => state.tagsPost;
export const friendsSelector = (state) => state.friends;
export const popUpSelector = (state) => state.popup;
